import { useCallback, useEffect, useRef, useState } from 'react';

import { UseTimeoutOptions } from '@/v1/main/domain/hooks';

export const useTimeout = (
    cb: () => void,
    interval: number,
    options: UseTimeoutOptions = {}
) => {
    console.log('useTimeout');
    const { immediate = false, onSetup, onTeardown } = options;
    const [enabled, setEnabled] = useState(false);

    let timer: ReturnType<typeof setTimeout> | null = null;
    const savedCallback = useRef<() => void | undefined>();

    useEffect(() => {
        savedCallback.current = cb;
    }, [cb]);

    const start = useCallback(() => {
        console.log('start');
        if (interval <= 0) return;
        setEnabled(true);
        onSetup?.();
        timer = setTimeout(() => {
            savedCallback.current && savedCallback.current();
        }, interval);
    }, [interval]);

    const stop = () => {
        console.log('stop');
        setEnabled(false);
        onTeardown?.();
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    console.log('interval', interval);
    const reset = useCallback(() => {
        console.log('reset');
        if (timer) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                savedCallback.current && savedCallback.current();
            }, interval);
        }
    }, [interval]);

    useEffect(() => {
        if (immediate) start();
    }, [immediate]);

    return { enabled, start, stop, reset };
};
